import request from '@/utils/request'

export function getRuleList(params) {
  return request({
    url: '/auth_rule/rules',
    method: 'get',
    params
  })
}

export function getRuleTreeList(params) {
  return request({
    url: '/auth_rule/tree',
    method: 'get',
    params
  })
}

export function getRuleChildrenList(params) {
  return request({
    url: '/auth/rule/children',
    method: 'get',
    params
  })
}

export function deleteRule(id) {
  return request({
    url: `/auth_rule/rules/${id}`,
    method: 'delete'
  })
}

export function clearRule(data) {
  return request({
    url: '/auth/rule/clear',
    method: 'delete',
    data
  })
}

export function updateRuleSort(id, listorder) {
  return request({
    url: `/auth/rule/${id}/sort`,
    method: 'patch',
    data: {
      listorder
    }
  })
}

export function enableRule(id) {
  return request({
    url: `/auth/rule/${id}/enable`,
    method: 'patch'
  })
}

export function disableRule(id) {
  return request({
    url: `/auth/rule/${id}/disable`,
    method: 'patch'
  })
}

// 获取分组树结构
export function ruleChildrenList() {
  return request({
    url: `/auth_rule/tree`,
    method: 'get'
  })
}

// 添加权限
export function createRule(data) {
  return request({
    url: '/auth_rule/rules',
    method: 'post',
    data
  })
}
// 权限详情
export function getRuleDetail(id) {
  return request({
    url: `/auth_rule/rules/${id}`,
    method: 'get'
  })
}
// 编辑修改权限
export function updateRule(id, data) {
  return request({
    url: `/auth_rule/rules/${id}`,
    method: 'put',
    data
  })
}
